/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDomainFromJSON, ApiDomainToJSON, } from './ApiDomain';
import { ApiDomainHosterFromJSON, ApiDomainHosterToJSON, } from './ApiDomainHoster';
import { ApiDomainStatusFromJSON, ApiDomainStatusToJSON, } from './ApiDomainStatus';
import { ApiLandingPathFromJSON, ApiLandingPathToJSON, } from './ApiLandingPath';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiExternalDomainFromJSON(json) {
    return ApiExternalDomainFromJSONTyped(json, false);
}
export function ApiExternalDomainFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'certificateApproved': !exists(json, 'certificateApproved') ? undefined : (new Date(json['certificateApproved'])),
        'certificateCname': !exists(json, 'certificateCname') ? undefined : json['certificateCname'],
        'certificateCnameValue': !exists(json, 'certificateCnameValue') ? undefined : json['certificateCnameValue'],
        'cnameName': !exists(json, 'cnameName') ? undefined : json['cnameName'],
        'cnameValue': !exists(json, 'cnameValue') ? undefined : json['cnameValue'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'domain': !exists(json, 'domain') ? undefined : ApiDomainFromJSON(json['domain']),
        'domainApproved': !exists(json, 'domainApproved') ? undefined : (new Date(json['domainApproved'])),
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'hoster': !exists(json, 'hoster') ? undefined : ApiDomainHosterFromJSON(json['hoster']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'paths': !exists(json, 'paths') ? undefined : (json['paths'].map(ApiLandingPathFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'readyAt': !exists(json, 'readyAt') ? undefined : (new Date(json['readyAt'])),
        'status': !exists(json, 'status') ? undefined : ApiDomainStatusFromJSON(json['status']),
        'subdomain': !exists(json, 'subdomain') ? undefined : json['subdomain'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiExternalDomainToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'certificateApproved': value.certificateApproved === undefined ? undefined : (value.certificateApproved.toISOString()),
        'certificateCname': value.certificateCname,
        'certificateCnameValue': value.certificateCnameValue,
        'cnameName': value.cnameName,
        'cnameValue': value.cnameValue,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'description': value.description,
        'domain': ApiDomainToJSON(value.domain),
        'domainApproved': value.domainApproved === undefined ? undefined : (value.domainApproved.toISOString()),
        'domainId': value.domainId,
        'hoster': ApiDomainHosterToJSON(value.hoster),
        'id': value.id,
        'name': value.name,
        'paths': value.paths === undefined ? undefined : (value.paths.map(ApiLandingPathToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'readyAt': value.readyAt === undefined ? undefined : (value.readyAt.toISOString()),
        'status': ApiDomainStatusToJSON(value.status),
        'subdomain': value.subdomain,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
